import { type ReactNode, useCallback, useMemo, useState } from "react";
import AlertContext from "./AlertContext";

interface Props {
  children?: ReactNode;
}

export function AlertProvider({ children }: Props) {
  const [show, setShow] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [error, setError] = useState(false);

  const handleShow = useCallback((text: string, isError: boolean) => {
    setAlertText(text);
    setError(isError);
    setShow(true);
  }, []);

  const handleHide = useCallback(() => {
    setShow(false);
  }, []);

  const value = useMemo(
    () => ({
      show,
      alertText,
      error,
      handleShow,
      handleHide,
    }),
    [alertText, error, handleHide, handleShow, show],
  );

  return (
    <AlertContext.Provider value={value}>{children}</AlertContext.Provider>
  );
}
